// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { Entity, EntityT } from '../tbs/entity.js';
import { Player, PlayerT } from '../tbs/player.js';
import { RngConfig, RngConfigT } from '../tbs/rng-config.js';
import { StateConfig, StateConfigT } from '../tbs/state-config.js';
import { StateMap, StateMapT } from '../tbs/state-map.js';
import { StateOnline, StateOnlineT } from '../tbs/state-online.js';
import { StateType } from '../tbs/state-type.js';


export class State implements flatbuffers.IUnpackableObject<StateT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):State {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsState(bb:flatbuffers.ByteBuffer, obj?:State):State {
  return (obj || new State()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsState(bb:flatbuffers.ByteBuffer, obj?:State):State {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new State()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

round():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 1;
}

online(obj?:StateOnline):StateOnline|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new StateOnline()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

config(obj?:StateConfig):StateConfig|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new StateConfig()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

map(obj?:StateMap):StateMap|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new StateMap()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

type():StateType {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : StateType.Game;
}

width():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 10;
}

height():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 10;
}

ents(index: number, obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

entsLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

players(index: number, obj?:Player):Player|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new Player()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

playersLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

turnPlayerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

rng(obj?:RngConfig):RngConfig|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? (obj || new RngConfig()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

ended():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startState(builder:flatbuffers.Builder) {
  builder.startObject(12);
}

static addRound(builder:flatbuffers.Builder, round:number) {
  builder.addFieldInt32(0, round, 1);
}

static addOnline(builder:flatbuffers.Builder, onlineOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, onlineOffset, 0);
}

static addConfig(builder:flatbuffers.Builder, configOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, configOffset, 0);
}

static addMap(builder:flatbuffers.Builder, mapOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, mapOffset, 0);
}

static addType(builder:flatbuffers.Builder, type:StateType) {
  builder.addFieldInt8(4, type, StateType.Game);
}

static addWidth(builder:flatbuffers.Builder, width:number) {
  builder.addFieldInt16(5, width, 10);
}

static addHeight(builder:flatbuffers.Builder, height:number) {
  builder.addFieldInt16(6, height, 10);
}

static addEnts(builder:flatbuffers.Builder, entsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, entsOffset, 0);
}

static createEntsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startEntsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addPlayers(builder:flatbuffers.Builder, playersOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, playersOffset, 0);
}

static createPlayersVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startPlayersVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addTurnPlayerId(builder:flatbuffers.Builder, turnPlayerId:number) {
  builder.addFieldInt32(9, turnPlayerId, -1);
}

static addRng(builder:flatbuffers.Builder, rngOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, rngOffset, 0);
}

static addEnded(builder:flatbuffers.Builder, ended:boolean) {
  builder.addFieldInt8(11, +ended, +false);
}

static endState(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): StateT {
  return new StateT(
    this.round(),
    (this.online() !== null ? this.online()!.unpack() : null),
    (this.config() !== null ? this.config()!.unpack() : null),
    (this.map() !== null ? this.map()!.unpack() : null),
    this.type(),
    this.width(),
    this.height(),
    this.bb!.createObjList<Entity, EntityT>(this.ents.bind(this), this.entsLength()),
    this.bb!.createObjList<Player, PlayerT>(this.players.bind(this), this.playersLength()),
    this.turnPlayerId(),
    (this.rng() !== null ? this.rng()!.unpack() : null),
    this.ended()
  );
}


unpackTo(_o: StateT): void {
  _o.round = this.round();
  _o.online = (this.online() !== null ? this.online()!.unpack() : null);
  _o.config = (this.config() !== null ? this.config()!.unpack() : null);
  _o.map = (this.map() !== null ? this.map()!.unpack() : null);
  _o.type = this.type();
  _o.width = this.width();
  _o.height = this.height();
  _o.ents = this.bb!.createObjList<Entity, EntityT>(this.ents.bind(this), this.entsLength());
  _o.players = this.bb!.createObjList<Player, PlayerT>(this.players.bind(this), this.playersLength());
  _o.turnPlayerId = this.turnPlayerId();
  _o.rng = (this.rng() !== null ? this.rng()!.unpack() : null);
  _o.ended = this.ended();
}
}

export class StateT implements flatbuffers.IGeneratedObject {
constructor(
  public round: number = 1,
  public online: StateOnlineT|null = null,
  public config: StateConfigT|null = null,
  public map: StateMapT|null = null,
  public type: StateType = StateType.Game,
  public width: number = 10,
  public height: number = 10,
  public ents: (EntityT)[] = [],
  public players: (PlayerT)[] = [],
  public turnPlayerId: number = -1,
  public rng: RngConfigT|null = null,
  public ended: boolean = false
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const online = (this.online !== null ? this.online!.pack(builder) : 0);
  const config = (this.config !== null ? this.config!.pack(builder) : 0);
  const map = (this.map !== null ? this.map!.pack(builder) : 0);
  const ents = State.createEntsVector(builder, builder.createObjectOffsetList(this.ents));
  const players = State.createPlayersVector(builder, builder.createObjectOffsetList(this.players));
  const rng = (this.rng !== null ? this.rng!.pack(builder) : 0);

  State.startState(builder);
  State.addRound(builder, this.round);
  State.addOnline(builder, online);
  State.addConfig(builder, config);
  State.addMap(builder, map);
  State.addType(builder, this.type);
  State.addWidth(builder, this.width);
  State.addHeight(builder, this.height);
  State.addEnts(builder, ents);
  State.addPlayers(builder, players);
  State.addTurnPlayerId(builder, this.turnPlayerId);
  State.addRng(builder, rng);
  State.addEnded(builder, this.ended);

  return State.endState(builder);
}
}
